module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/press/suzhou-yun-logistics-technology-selects-linescape/suzhou-yun-logistics-technology-selects-linescape.scss
// module id = 869
// module chunks = 0